module.exports = __webpack_public_path__ + "static/img/200192.1a361e26.png";